const LabelValueSetType = Symbol();

export class LabelValueSet {
    [LabelValueSetType]: any;
    readonly label: string;
    readonly value: string;

    constructor(label: string, value: string) {
        this.label = label;
        this.value = value;
    }
}
